<template>
	<div class="mcontactoFormHeader puiformheader">
	</div>
</template>

<script>
import { PuiFormHeaderMixin } from '@Pui9Components';

export default {
	name: 'mcontacto-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'mcontacto'
		};
	},
	computed: {
	}
}
</script>
